import request from '@/utils/workFlowRequest'
import constants from '@/utils/constants'
const WorkFlowService = {
  state: {},

  mutations: {},

  actions: {
    workflowPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'workflow/page', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowSave({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'workflow/save', params).then(response => {
          const data = response
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowRemove({ commit }, ids) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'workflow/remove', ids).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowUpdate({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + `workflow/${params.id}/update`, params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowSaveContent({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + `workflow/saveContent/` + params.id, params.content).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowGetDetailsById({ commit }, id) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + `workflow/getDetailsById/${id}`).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowChangeStatus({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + `workflow/changeStatus/${params.id}`, params.status).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    workflowListByFormId({ commit }, formId) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + `workflow/listByFormId`, { formId: formId }).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 用户分页
    */
    workflowUserPage({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get(constants.WORKFLOW + 'user/page', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    /**
    * 同步单个用户
    */
    syncOneUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'user/syncUser', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    fileUpload({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.fileUpload(constants.WORKFLOW + 'file/upload', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // Base64图片上传
    base64Upload({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post(constants.WORKFLOW + 'file/base64Upload', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }

  }
}

export default WorkFlowService
